import i18n from '@/i18n'

export default {

  setLang({ dispatch, commit, state }, v){
    if(state.lang !== v){
      i18n.locale = v
      commit('setLangu', v)
    }
  },

  setMenu({ dispatch, commit, state }, v) {
    commit('setMenu', v)
  },

  theme({dispatch , commit , state} , v){
    commit('setTheme' , v)
  },

  setAutoSignin({dispatch , commit , state} , v){
    commit('setAutoSignin' , v)
  }
}
